import gsap from "gsap";
import { DrawSVGPlugin, Flip } from "gsap/all";

gsap.registerPlugin(DrawSVGPlugin);

export function initLoader(lenis, onComplete) {
  if (typeof gsap === "undefined" || typeof Flip === "undefined") {
    console.warn("GSAP o Flip plugin no están cargados.");
    return;
  }

  gsap.registerPlugin(Flip);

  const loader = document.getElementById("heroLoader");
  const heroName = document.getElementById("heroName");
  const dest = document.getElementById("heroNameDest");

  if (!loader || !heroName || !dest) return;

  const master = gsap.timeline();

  // 🎯 OCULTAR ARROWS DESDE EL INICIO
  gsap.set(".arrow-svg", { opacity: 0 });

  gsap.set(heroName, {
    opacity: 0,
    filter: "blur(20px)",
    scale: 1.05,
  });

  master.to(heroName, {
    opacity: 1,
    filter: "blur(0px)",
    scale: 1,
    duration: 1.4,
    ease: "power2.out",
  });

  master.to({}, { duration: 0.5 });

  master.add(() => {
    const state = Flip.getState(heroName);
    dest.appendChild(heroName);

    Flip.from(state, {
      duration: 1,
      ease: "power3.inOut",
      absolute: true,
      onComplete: removeLoaderAndReveal,
    });

    const secondLine = heroName.querySelector('[data-line="1"]');
    if (secondLine) {
      gsap.to(secondLine, {
        paddingLeft: "15%",
        duration: 1,
        ease: "power3.inOut",
      });
    }
  });

  function removeLoaderAndReveal() {
    gsap.to(loader, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.out",
      onComplete: () => {
        loader.style.display = "none";

        // Desbloquear scroll
        if (lenis) lenis.start();

        // 🎯 EJECUTAR CALLBACK (inicializar animaciones de scroll)
        if (typeof onComplete === "function") {
          onComplete();
        }
      },
    });

    const revealTl = gsap.timeline({ delay: 0.1 });

    revealTl.to(".hero-landing__card-row", {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: "power2.out",
    });

    revealTl.to(
      ".hero-landing__float-tag",
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power2.out",
      },
      "-=0.4",
    );

    revealTl.to(
      ".hero-landing__tag-portfolio",
      {
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
      },
      "-=0.3",
    );

    // 🎨 ANIMAR LAS ARROWS DESPUÉS DE QUE APAREZCAN LOS TAGS
    revealTl.add(animateArrows, "-=0.8");
  }

  function animateArrows() {
    const arrows = document.querySelectorAll(".arrow-svg");
    console.log("hola");
    arrows.forEach((arrow, index) => {
      const strokePath = arrow.querySelector(".arrow-path");

      if (!strokePath) return;

      gsap.set(arrow, { opacity: 1 });

      // DrawSVG anima el stroke
      gsap.fromTo(
        strokePath,
        {
          drawSVG: "0% 0%", // Empieza desde el punto inicial
        },
        {
          drawSVG: "0% 100%", // Se dibuja hacia adelante
          duration: 1.5,
          ease: "power2.inOut",
          delay: index * 0.25,
        },
      );
    });
  }
}
